import type { FlightSearchFormLabels } from "../../labels";

type PassengersDropdownLabelProperties = {
  adultsCount: number;
  childrenCount: number;
  infantsCount: number;
  labels: FlightSearchFormLabels["passengersDropdown"];
};

export const passengersDropdownLabel = ({
  adultsCount,
  childrenCount,
  infantsCount,
  labels,
}: PassengersDropdownLabelProperties) => {
  let label = "";

  if (adultsCount > 0) {
    label += `${adultsCount.toString()} ${adultsCount === 1 ? labels.adult : labels.adults}`;
  }
  if (childrenCount > 0) {
    if (adultsCount > 0) {
      label += ", ";
    }
    label += `${childrenCount.toString()} ${childrenCount === 1 ? labels.child : labels.children}`;
  }
  if (infantsCount > 0 && adultsCount >= infantsCount) {
    label += ", ";
    label += `${infantsCount.toString()} ${infantsCount === 1 ? labels.infant : labels.infants}`;
  }

  const travelerCount = adultsCount + childrenCount + infantsCount;
  if (adultsCount > 0 && childrenCount > 0 && infantsCount > 0) {
    label = `${travelerCount.toString()} ${labels.travelers}`;
  }

  if (travelerCount === 0) {
    label = labels.travelers;
  }

  return label;
};
